import React, {useState, useEffect} from 'react'
import { Input } from "antd";

const ActionTakenDetailsInput = ({
    formState,
    setFormState,
    actionValidations,
    setActionValidations
}) => {
    const [maxChar, setMaxChar] = useState("0");
    const data = formState.immediateActionTakenDetails.length
    useEffect(() => {
        let mounted = true;

        if(mounted)
            setMaxChar(formState.immediateActionTakenDetails.length);

        return () => {
            mounted = false;
        }
    }, [data, formState.immediateActionTakenDetails])

    return (
        <>
            <span style={{color: "red"}}>*</span> Details of Action Taken
            <div className="generalInfoContainer">
                <Input.TextArea
                    placeholder="Enter Details (max length 500 characters)"
                    onChange={(e) => {
                        setFormState(prevState => ({ ...prevState, immediateActionTakenDetails: e.target.value }));
                        if(actionValidations.immediateActionTakenDetails !== "")
                            setActionValidations(prevState => ({ ...prevState, immediateActionTakenDetails: "" })) 
                        setMaxChar(e.target.value.length);
                    }}
                    value={formState.immediateActionTakenDetails}
                    style={{
                        resize: "none",
                        height: "100px",
                        marginTop: "8px"
                    }}
                    maxLength={500}
                    className={actionValidations.immediateActionTakenDetails !== "" ? "newInputText validationInputText" : "newInputText"}
                />
                {actionValidations.immediateActionTakenDetails && 
                    <span className="validationMessage2">{actionValidations.immediateActionTakenDetails}</span>
                }
                <span className="maxCharMessage">{maxChar}/500</span>
            </div>
        </>
    )
}

export default ActionTakenDetailsInput
